import { Handle } from '../handles';
import Element, { ElementType } from '../element';
import store from '@/store';
import { Pair } from '../pair';
import { AddHandlesToFrontCommand } from './addHandlesToFrontCommand';
import { BaseCommand } from './baseCommand';

export default class ChangeHandlesCommand extends BaseCommand {

    private previous!: Element[];
    private bindings: Array<Pair<Element, Element>> = [];
    private previousHandle!: Handle;

    constructor(
        scenePreview: any,
        private handle: Handle,
    ) {
        super(scenePreview);
    }

    public execute() {
        this.handlePreviousHandles();
        this.addNewHandles();
        this.removeOldHandles();
        store.dispatch('sapCalculate');
    }

    public revert() {
        store.commit('selectHandle', this.previousHandle);
        this.scenePreview.elements.push(...this.previous);
        this.previous.forEach((x) => x.isVisible = store.getters.scene.areFrontsVisible);
        this.bindings.forEach((x) => x.x.bind(x.y));
        this.revertCommands();
    }

    private handlePreviousHandles() {
        this.previousHandle = store.getters.shaders.selectedHandle;
        store.commit('selectHandle', this.handle);
        this.previous = this.scenePreview.elements
            .filter((x: Element) => x.type === ElementType.HANDLE);
    }

    private addNewHandles() {
        const fronts = this.scenePreview.elements.filter((x: Element) => x.type === ElementType.FRONT);
        fronts.forEach((front: Element) => {
            const command = new AddHandlesToFrontCommand(front, this.scenePreview);
            this.addCommand(command);
        });
    }

    private removeOldHandles() {
        this.previous.forEach((x: Element) => {
            const front = x.bindings.find((b) => b.type === ElementType.FRONT)!;
            this.bindings.push(new Pair(x, front));
            x.unbind(front);
            x.isVisible = false;
            this.scenePreview.elements.splice(this.scenePreview.elements.indexOf(x), 1);
        });
    }
}
